'use client'
import { TypeValidRegionKey } from '@/utils'
import { useEffect, useState } from 'react'

export const defaultCommercial = [{
  client: 'MAMMAFIORE DISTRIBUTION',
  contact: {
    email: 'comercial@mammafiore.eu'
  }
}]

export async function getCommercialsByCountry(country:TypeValidRegionKey = 'ES') {
  if(country !== 'ES') return []
  const data = await fetch(`/json/countries/${country}-commercials.json`)
  return data.json()
}

export const useCommercialsForSubdivision = (country: TypeValidRegionKey, subdivision: string) => {
  const [commercials, setCommercials] = useState(defaultCommercial)

  useEffect(() => {
    if (country === 'ES') {
      getCommercialsByCountry(country).then(res => {
        const filtered = res.filter(item => item.operate_in?.includes(subdivision))
        setCommercials(filtered.length ? filtered : defaultCommercial)
      })
    }
  }, [country, subdivision])

  return commercials
}


